<template>
  <div class="main-content">
    <div class="h2"><strong>密碼重置</strong></div>
    <div class="subtitle">
      已經有帳戶了嗎？<a href="#" @click="$store.commit('setLoginCurrentContent', 'login')">帳戶登錄</a>
    </div>
    <div class="form-div">
      <input :type="show_password ? 'text' : 'password'" class="form-input" id="reset-password" placeholder=" "
        v-model.lazy="reset_password.password">
      <label for="reset-password" class="form-label">登錄密碼</label>
      <div type="button" class="switch-password" v-show="show_password" @click="show_password = !show_password">
        <i class="fa-regular fa-eye-slash"></i>
      </div>
      <div type="button" class="switch-password" v-show="!show_password" @click="show_password = !show_password">
        <i class="fa-regular fa-eye"></i>
      </div>
    </div>
    <div class="form-div">
      <input :type="show_password ? 'text' : 'password'" class="form-input" id="reset-confirmation-password" placeholder=" "
        v-model.lazy="reset_password.password_confirmation">
      <label for="reset-confirmation-password" class="form-label">確認密碼</label>
      <div type="button" class="switch-password" v-show="show_password" @click="show_password = !show_password">
        <i class="fa-regular fa-eye-slash"></i>
      </div>
      <div type="button" class="switch-password" v-show="!show_password" @click="show_password = !show_password">
        <i class="fa-regular fa-eye"></i>
      </div>
    </div>

    <div class="send-bag">
      <div id="error-password" class="text-danger"></div>
      <button class="form-button bg-success" @click="resetPassword">密碼重置確認</button>
    </div>
    <hr>
    <copyright-component></copyright-component>
  </div>
</template>

<script>
import CopyrightComponent from '../layouts/CopyrightComponent.vue';
import { validation } from '../mixins/validation.js';
import { axiosMixins } from '../mixins/axiosErrorMessage.js';

export default {
  mixins: [validation, axiosMixins],
  data() {
    return {
      reset_password: {
        password: '',
        password_confirmation: ''
      },
      show_password: false
    }
  },
  methods: {
    resetPassword() {
      if (!this.validateBeforeSubmit()) { return }
      const error_element = this.$el.querySelector('#error-password')
      const axios_data = {
        password: this.reset_password.password,
        password_confirmation: this.reset_password.password_confirmation,
      }
      const axios_headers = { "token": this.$store.getters.resetpasswordVerifyToken };
      axios.post(base_url + '/api/reset-password', axios_data, { headers: axios_headers })
        .then((response) => {
          if (response.data.status === "success") {
            this.$store.commit('setResetpasswordVerifyToken', '');
            this.$store.commit('setLoginCurrentContent', 'login')
          } else {
            error_element.innerHTML = "驗證系統忙碌，請稍後再試";
          }
        }).catch((error) => {
          this.axiosMessage(error);
          error_element.innerHTML = "驗證系統忙碌，請稍後再試";
        });
      setTimeout(() => {
        if (error_element.innerHTML !== "") {
          error_element.innerHTML = "";
        }
      }, 3000);
    }
  },
  components: { CopyrightComponent },
}
</script>
